module.exports = __webpack_public_path__ + "img/wz-7-4-3.7dc275b7.jpg";